import { faClose, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import './ProductCategory.css';
import { Modal, MultiSelect } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import B2BSelect from '../../components/common/B2BSelect';
import { createB2BAPI } from '../../api/Interceptor';
import { MappedProductContext } from '../../Context/MappedProductContext';
import { useMediaQuery } from '@mui/material';

const MappedProductCategory = ({ vendorId }) => {
    const { product, setProduct, inputError, setInputError, setHasMultiSelectCategoryMandatory } = useContext(MappedProductContext);

    const initialState = { key: '', value: {}, heirarchyLabel: "", options: [], openModal: false, count: 2, multiSelect: false }
    const [categorys, setCategorys] = useState([]);
    const [categoryName, setCategoryName] = useState([]);
         const isMobile = useMediaQuery("(max-width: 767px)");
    const [selectedPairs, setSelectedPairs] = useState([{ ...initialState }]);
    const B2B_API = createB2BAPI();
    const [opened, { open, close }] = useDisclosure(false);
    const [multiSelect, setMultiselect] = useState({})
    const [selectedValues, setSelectedValues] = useState({});
    const [unique, setUnique] = useState([]);
    useEffect(() => {
        fetchcategory();
    }, []);
    useEffect(() => {
        const updatedSelectedValues = {};
        const uniqueCategoryKeys = [
            ...new Set(product.productCategoriesList?.map(category => category?.productGroupName))
        ];
        uniqueCategoryKeys.forEach((category) => {

            const selectedForCategory = product.productCategoriesList
                .filter((item) => item.productGroupName === category)
                .map((item) => item.id) || [];

            updatedSelectedValues[category] = selectedForCategory;
        });
        setSelectedValues(updatedSelectedValues);
    }, [selectedPairs]);


    const fetchcategory = async () => {
        try {
            const res = await B2B_API.get('product-category?status=ACTIVE').json();
            const categories = res?.response?.filter(cat => cat.name?.toLowerCase() !== 'fabric content');
            const categoryName = categories.map(res => (res.name));
            const mandatoryCategories = categories?.filter(cat => cat.isMandatory)
            const getLastChildCategories = (selectedKey) => {
                const childCategory = categories.find(cat => cat.name === selectedKey)?.child || [];
                return childCategory.reduce((acc, category) => {
                    if (!category.child || category.child.length === 0) {
                        acc.push({
                            ...category,
                            value: category.id,
                            label: category.name
                        });
                    } else {

                        acc.push(...getLastChildCategories(category.child));
                    }
                    return acc;
                }, []);
            };
            categoryName.forEach(item => {
                setMultiselect(prev => ({
                    ...prev,
                    [item]: getLastChildCategories(item),
                }));
            });
            setCategoryName(categoryName)
            setCategorys(categories)
            setCategorysAndselectedPairs(mandatoryCategories)
        } catch (error) {
            console.error('Error fetching categorys:', error);
        }
    };

    const setCategorysAndselectedPairs = (mandatoryCategories = []) => {
        const productCategoriesList = product.productCategoriesList || [];
        let formattedCategories = [];
        const uniqueCategoryKeys = new Set();

        if (product?.productCategories?.length > 0 || _.size(productCategoriesList) > 0) {
            if (product?.productCategories?.length > 0) {
                formattedCategories = product.productCategories.map(category => ({
                    ...initialState,
                    options: category?.options,
                    key: category?.key,
                    isMandatory: category?.isMandatory,
                    heirarchyLabel: category.heirarchyLabel,
                    value: category?.value,
                    // multiSelect: false,
                }));
            }

            _.forEach(productCategoriesList, prod => {
                if (!uniqueCategoryKeys.has(prod.productGroupName)) {
                    uniqueCategoryKeys.add(prod.productGroupName);
                    formattedCategories.push({
                        ...initialState,
                        heirarchyLabel: prod.name,
                        key: prod.productGroupName,
                        multiSelect: prod.multiSelect,
                        isMandatory: mandatoryCategories.find(cat => cat.name === prod.productGroupName)?.isMandatory || false,
                        options: getParentChild(prod.productGroupName) || [],
                    });
                }
            });
        }

        if (formattedCategories.length > 0) {
            formattedCategories.sort((a, b) => (b.isMandatory === true) - (a.isMandatory === true));
            setSelectedPairs(formattedCategories);            // setProduct(prev => ({ ...prev, productCategories: formattedCategories }));
        } else if (mandatoryCategories.length > 0 && productCategoriesList.length === 0) {
            formattedCategories = mandatoryCategories.map(category => ({
                ...initialState,
                options: category?.child,
                key: category.name,
                isMandatory: true,
                multiSelect: category.multiSelect,
            }));
            setSelectedPairs(formattedCategories);
            setHasMultiSelectCategoryMandatory(mandatoryCategories);
            setProduct(prev => ({ ...prev, productCategories: formattedCategories.filter(cat => !cat.multiSelect) }));
        }
    }


    const handleSelectChange = (index, selectedKey) => {
        const newPairs = [...selectedPairs];
        newPairs[index] = { ...initialState, key: selectedKey };
        const childCategory = categorys.filter(cat => cat.name === selectedKey)?.[0];
        if (!childCategory?.multiSelect) {
            setProduct(prev => ({ ...prev, productCategories: newPairs }));
        } else {
            newPairs[index].multiSelect = true
        }
        newPairs[index].options = childCategory?.child || [];
        setSelectedPairs(newPairs);
        setInputError("");
    };

    const openModals = (index, value) => {
        const newPairs = [...selectedPairs];
        newPairs[index].openModal = value;
        setSelectedPairs(newPairs);
    };

    const addNewPair = () => {
        setSelectedPairs([...selectedPairs, { ...initialState }]);
    };

    const removePair = (index, catname) => {
        const newPairs = [...selectedPairs];
        newPairs.splice(index, 1);
        setSelectedPairs(newPairs);
        if (catname) {
            setSelectedValues((prevState) => {
                const newState = { ...prevState };
                delete newState[catname];
                return newState;
            });
            const list = product?.productCategoriesList?.filter(item => item.productGroupName !== catname)
            setProduct((prevProduct) => ({
                ...prevProduct,
                productCategoriesList: list

            }));

        }
        setProduct(prev => ({ ...prev, productCategories: (newPairs || []).filter(cat => !cat.multiSelect) }));
    };

    const selectcategory = (index, cat) => {
        const newPairs = [...selectedPairs]
        const label = newPairs[index]?.heirarchyLabel
        newPairs[index].value = cat || {};
        const hasNoChild = _.size(cat?.child) == 0;
        if (cat) {
            if (hasNoChild) {
                const splitLabel = label.split(" / ");
                if (splitLabel.length === (newPairs[index].count - 1)) {
                    splitLabel[splitLabel.length - 1] = cat.name
                    newPairs[index].heirarchyLabel = _.join(splitLabel, " / ")
                } else {
                    newPairs[index].heirarchyLabel = label.concat(label ? " / " : "").concat(cat.name)
                }
                newPairs[index].openModal = false
                newPairs[index].lastChildName = cat.name
                setProduct(prev => ({ ...prev, productCategories: (newPairs || []).filter(cat => !cat.multiSelect) }));
            } else {
                newPairs[index].heirarchyLabel = label.concat(label ? " / " : "").concat(cat.name)
                let count = newPairs[index].count
                newPairs[index].count = ++count;
                newPairs[index].options = cat.child
            }
        } else {
            newPairs[index].heirarchyLabel = ""
            newPairs[index].count = 2;
            newPairs[index].options = getParentChild(newPairs[index].key)
        }
        setSelectedPairs(newPairs);
        setInputError("");
    }

    const removeCategory = (index) => {
        openModals(index, false)
        selectcategory(index, null)
    }

    const getParentChild = (key) => {
        const childCategory = categorys.find(cat => cat.name === key)?.child || [];
        return childCategory;
    }

    const getAvailableKeys = (currentIndex, catkey) => {
        const selectedKeys = selectedPairs.map(pair => pair.key);
        return categoryName.filter(key => !selectedKeys.includes(key) || key === catkey || selectedPairs[currentIndex].key === key);
    };



    return (
        <section className="product-category-section" style={{margin: '3rem'}}>
                    <div style={{ display: 'flex', flexDirection: 'column', rowGap: '1rem' }}>
                        <div className="product-category-g-row">
                            <div className="product-category-g-col-category" style={{width:isMobile?'50%' :'30%'}} >
                                <span className="product-category-text-label">Category</span>
                                <span className="error-message"> *</span>
                            </div>
                            <div className="product-category-g-col-category"style={{width:'30%'}} >
                                <span className="product-category-text-label">Level</span>
                                <span className="error-message"> *</span>
                            </div>
                            <div className="product-category-g-col-category" style={{ width: '5rem', flex: 'none' }}></div>
                        </div>

                        {selectedPairs.map((pair, index) => (
                            <div key={index} className="product-category-g-row">
                                <div className="product-category-g-col-category"style={{width:'30%'}} >
                                    <B2BSelect
                                        value={pair.key}
                                        data={getAvailableKeys(index)}
                                        onChange={(e) => handleSelectChange(index, e)}
                                        error={inputError[index]?.categoryErrorMessage}
                                        className='input-textField'
                                        disabled={true}
                                    />
                                </div>
                                <div className="product-category-g-col-category" style={{ flexDirection: 'column' }}>
                                    {!pair.multiSelect ?
                                        <div className='product-category-inputField'>
                                            <input
                                                placeholder="Select a category"
                                                disabled={true}
                                                style={{ cursor: pair.key === null ? 'not-allowed' : 'pointer' }}
                                                readOnly
                                                type="text"
                                                value={pair.heirarchyLabel}
                                                onClick={() => openModals(index, true)}
                                                onChange={() => { }}
                                            />
                                        </div>
                                        :
                                        <div>
                                            <MultiSelect
                                                data={multiSelect[pair.key]
                                                    ?.map((item) => ({ value: item.id, label: item.name, }))}
                                                value={selectedValues[pair.key]}
                                                onChange={(newSelectedValues) => {
                                                    const categoryKey = pair.key;
                                                    setSelectedValues((prevValues) => {

                                                        const updatedValues = {
                                                            ...prevValues,
                                                            [categoryKey]: newSelectedValues,
                                                        };
                                                        const list = product?.productCategoriesList?.filter(item => item?.productGroupName !== categoryKey) || []
                                                        setProduct((prevProduct) => ({
                                                            ...prevProduct,
                                                            productCategoriesList: [...list, ...multiSelect[categoryKey]?.filter(item =>
                                                                newSelectedValues.includes(item.id)
                                                            )]
                                                        }));
                                                        return updatedValues;
                                                    });
                                                }}
                                                searchable
                                                clearable
                                               disabled={true}
                                            />
                                        </div>
                                    }
                                    <Modal
                                        opened={pair.openModal}
                                        onClose={() => openModals(index, false)}
                                        title="Search all categories"
                                        centered
                                        size={"lg"}
                                    >
                                        <div>
                                            {!pair.value || pair.options.length > 0 ? (
                                                <div style={{ padding: '0 20px' }}>
                                                    <input type="text" id="product-category-search-input" placeholder="Enter a category name" />
                                                </div>
                                            ) : ''}
                                            {!pair.value || pair.options.length > 0 ? (
                                                <div role="list">
                                                    <div className='product-category-child'>
                                                        <span className='product-category-child-level'>Level {pair.count}</span>
                                                        <hr />
                                                    </div>
                                                    <div className='product-category-child'>
                                                        {pair.options.map((cat) => (
                                                            <ul className="product-category-child-list" key={cat.id}>
                                                                <li tabIndex="0" onClick={() => selectcategory(index, cat)}>
                                                                    <span>{cat.name}</span>
                                                                </li>
                                                            </ul>
                                                        ))}
                                                    </div>
                                                </div>
                                            ) : ''}
                                            {pair.heirarchyLabel && (
                                                <div className="product-category-heirarchyLevel">
                                                    <span className="vd-text-body vd-util-text-overflow-break-word">{pair.heirarchyLabel}</span>
                                                    <button
                                                        aria-label="Remove selected category"
                                                        type="button"
                                                        className="vd-btn vd-btn--icon-supplementary"
                                                        onClick={() => removeCategory(index)}
                                                    >
                                                        <FontAwesomeIcon className='fa' icon={faTrash} />
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </Modal>

                                    <span className='error-message'>
                                        {inputError[index]?.categorysErrorMessage}
                                    </span>
                                </div>
                                {/* <div className="product-category-g-col-category" style={{ width: '5rem', flex: 'none', justifyContent: 'center' }}>
                                    {!pair.openModal && index > 0 && pair.key !== 'Fabric Type' && (
                                        <button type="button" disabled={pair.isMandatory} className="product-category-btn" onClick={() => removePair(+index, categorys.isMandatory === true ? categorys.name : pair.key)}>
                                            <FontAwesomeIcon className="fa product-category-icon" icon={faTrash} />
                                        </button>
                                    )}
                                </div> */}

                            </div>
                        ))}
                    </div>
        </section>
    );
};

export default MappedProductCategory;